
import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class CloseWindow extends Vue {
    beforeCreate(){
        window.parent?.close();
        window.close();
    }

}
